import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEye = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentcolor",
		id: "svg_1",
		d: "m11.94509,5.20932c-4.05618,-0.06843 -8.25121,2.76618 -10.88859,5.66919c-0.27683,0.30734 -0.43004,0.70632 -0.43004,1.11995c0,0.41362 0.15321,0.81257 0.43004,1.12c2.58002,2.8416 6.76298,5.74164 10.88859,5.67221c4.12565,0.06943 8.30962,-2.83061 10.89161,-5.67221c0.27688,-0.30743 0.42999,-0.70638 0.42999,-1.12c0,-0.41363 -0.15311,-0.81261 -0.42999,-1.11995c-2.64043,-2.90301 -6.83539,-5.73762 -10.89161,-5.66919",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentcolor",
		id: "svg_2",
		d: "m16.42183,12.00118c-0.00028,0.87446 -0.25979,1.72925 -0.74584,2.45627c-0.48591,0.72702 -1.1767,1.29358 -1.98466,1.62808s-1.69703,0.42195 -2.55471,0.25116c-0.85766,-0.17079 -1.64546,-0.59189 -2.26374,-1.21038c-0.61829,-0.61849 -1.03931,-1.40635 -1.20983,-2.26412c-0.17052,-0.85762 -0.08289,-1.74671 0.25182,-2.55463s0.90147,-1.49844 1.62861,-1.98426c0.72715,-0.48584 1.58201,-0.74513 2.45651,-0.74513c0.58085,-0.00016 1.15604,0.11415 1.69261,0.33638c0.5367,0.22224 1.02417,0.54805 1.43479,0.95881c0.41077,0.41076 0.73636,0.89842 0.95851,1.43511c0.22201,0.53669 0.3362,1.11188 0.33592,1.6927",
		strokeWidth: 1.5
	}));
});
export default SvgEye;
